import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';

export type Notification = { id: string; title: string; body: string | null; link: string | null; source: string | null; is_read: boolean; created_at: string };

// Unread badge count — polled lightly so the bell stays current.
export function useUnreadCount() {
  const { data } = useQuery({
    queryKey: ['notif-unread'],
    queryFn: () => api.get<{ unread: number }>('/notifications/unread-count'),
    refetchInterval: 60000,
  });
  return data?.unread || 0;
}
